<ng-container>
  <main role="main" id="error-content" class="pre-loader">
    <section>
      <h1>Oops!</h1>
      <p>We're having trouble connecting you to the AmiLearn Learning Portal.</p>
      <p>Please close your browser window and try again in a few minutes. If you continue to experience problems, please contact

        <a href="{{supportEmailHref}}">support@meetami.ca</a>.

      </p>
      <p>We're here to help!</p>
      <p *ngIf="publicErrorCode">Error code: {{publicErrorCode}}</p>
    </section>
  </main>
</ng-container>
